export class AssignmentGroupConstants {
    // Constants
    public static readonly AssignmentGroupTitle = 'Assignment Group';
    public static readonly CreateAssignmentGroupButtonTitle = 'Add Assignment Group';
    public static readonly Scope_Tree_Select_PlaceHolder: string = 'eQMS Scope';

    //Spinner Messages
    public static readonly AssignmentGroup_Save_InProgress: string =
      'Assignment Group Save is in progress';
  
    // confirmation Messages
    public static readonly AssignmentGroup_Slider_Confirmation_Header: string =
      'Confirmation';
  public static readonly AssignmentGroup_Slider_Confirmation_Text: string =
    'Any unsaved change will be lost when closing the screen. Do you want to continue?';

    // Toaster Messages and Severity
    public static readonly Severity_Success: string = 'success';
    public static readonly Severity_Info: string = 'info';
    public static readonly Severity_Err: string = 'error';
  
    public static readonly AssignmentGroup_Created_Success: string =
      'Assignment Group Created Successfully';
    public static readonly AssignmentGroup_Creation_Failed: string =
      'Assignment Group Failed to save'; 
      public static readonly AssignmentGroup_Updated_Success: string =
      'Assignment Group Updated Successfully';
    public static readonly AssignmentGroup_Updated_Failed: string =
      'Assignment Group Failed to update'; 

  // Error messages
  public static readonly AssignmentGroup_Scope_Required: string = 'Scope is required.';
  public static readonly AssignmentGroup_Name_Required: string =
    'Name is required.';
  public static readonly AssignmentGroup_Assignment_Required: string =
    'Assignment is required.';
  public static readonly AssignmentGroup_Users_Required: string =
    'User is required.';

    public static readonly AssignmentGroup_Creation_Error_Message_Header_Text: string =
      'Please correct the following errors to create the Assignment Group.';
      
    public static readonly AssignmentGroup_Duplication_Error_Message: string =
    'Assignment group with the same name already exists';
       
    public static readonly AssignmentGroup_Duplication_Error_Message_Text: string =
    'The Name of an Active Assignment Group must be unique under a given eQMS Scope. There is already an existing active Assignment Group with the Name';

    public static readonly AssignmentGroup_Users: string = 'users';

      //const values
    public static readonly AssignmentGroup_Default_Requiredfields = {
      scope: false,
      name: false,
      assignment: false,
      users: false,
    };

}
